import * as S from './styles';

import React, {
    useState,
    useEffect,
    useCallback,
    ChangeEvent
  } from "react";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import FormLabel from 'react-bootstrap/FormLabel';

import logoReanimateColors from '../../assets/images/logo-re.animate-colors-2.png'
import iconArrowLeft from '../../assets/images/icon-arrow-left-2.png'

import Menu from '../../components/Menu';
import useReadLocalStorage from '../../hooks/useReadLocalStorage';
import { useAuth } from '../../context/auth'
import api from "../../services/api";
import { useRef } from 'react';
import { FormHandles, SubmitHandler } from '@unform/core';

import Input from '../../components/Input'
import Textarea from '../../components/Textarea'
import Switch from "react-switch";

function CompanyCreate(props: any) {
  const { sendCompany, getListProducts } = useAuth()
  const formRef = useRef<FormHandles>(null)

  const token = useReadLocalStorage<[]>('@login-reanimate/token');
  const [status, setStatus] = useState("1")
  const [unlimited, setUnlimited] = useState("0")
  const [products, setproducts] = useState([])
  const [image, setImage] = useState(null)

  const [listProducts, setlistProducts] = useState([])

  const changeStatus = (target: any) => {
    let status = target ? '1' : '0';
    setStatus(status)
  }

  const changeUnlimited = (target: any) => {
    let unlimited = target ? '1' : '0';
    setUnlimited(unlimited)
  }

  const changeProducts = (e: any) => {
    if(e.target.checked === true)   
      e.target.classList.add("product-active");
    else
      e.target.classList.remove("product-active");

      var elementos = document.getElementsByClassName('product-active');

      let products: any = [];
      for (var i = 0; i < elementos.length; i++) {
        products.push(elementos[i].getAttribute('value'));
      }

      setproducts(products)
  }

  React.useEffect(() => {
    api.defaults.headers.Authorization = `Bearer ${token}`;

    getListProducts([]).then(res => {
      setlistProducts(res)
    })

  },[])

  const handleSubmit: SubmitHandler<FormData> = (data) => {
    const formData = new FormData();

    for (const [key, value] of Object.entries(data)) {

      if(key !== 'products') {
        //@ts-ignore
        formData.append(key, data[key]);
      }

    }

    for (let i = 0; i < products.length; i++) {
      //@ts-ignore
      formData.append("products[]", products[i]);
    }

    if (image !== null) {
      //@ts-ignore
      formData.append("files", image);
    }

    sendCompany(formData)
  }

  const handlePreview = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    
    if (!file) {
      setImage(null);
    }

    //@ts-ignore
    setImage(file);
    
  }, []);

  const handleBack = () => {
    props.history.goBack()
  }

  return (
    <S.Container>

      <Menu />

      <Container fluid>
        <Row>
          <Col md={12}>
            <S.CompanyWrapper>
              <img src={logoReanimateColors} className="logo-reanimate-colors" data-aos="zoom-in" data-aos-duration="800" />

              <h1 data-aos="fade-up" data-aos-duration="800">Empresas</h1>

              <img src={iconArrowLeft} onClick={handleBack} className="icon-arrow-left" data-aos="fade-up" data-aos-duration="800" data-aos-delay="300" />

              <Container fluid className="p-0">
                <Row>
                  <Col md={12} lg={12} xl={12}>


                    <S.CompanyForm ref={formRef} onSubmit={handleSubmit} data-aos="fade-up" data-aos-duration="800" data-aos-delay="500">

                      <Container fluid className="p-0">
                        <Row>
                          <Col md={12} lg={3}>

                            <h4>Status de uso:</h4>

                            <Form.Group className="box-status">
                              <Switch
                                onChange={changeStatus}
                                checked={status == "1"}
                                className="react-switch"
                              />
                            </Form.Group>

                            <Form.Group className="d-none">
                              <label>Status</label><br />
                              ATIVO<Input name="status" placeholder="Sim" type="radio" value={status} checked={status == "1"}  onChange={e => changeStatus(1)}  />
                              INATIVO<Input name="status" placeholder="Não" type="radio" value={status} checked={status == "0"}  onChange={e => changeStatus(0)}  />
                            </Form.Group>

                            <h4>Módulos ativos:</h4>

                            {listProducts?.map((product: any) => (
                              <div key={product.product_id} className="product-item">

                                <Input name="products[]" type="checkbox" 
                                  checked={
                                    //@ts-ignore
                                    products.indexOf(product.product_uuid) > -1
                                  } 
                                  value={product.product_uuid} onChange={e => changeProducts(e)}
                                />

                                <label id={product.product_title.toLowerCase().replace(' ', '-')}>{product.product_title}</label>
                              </div>
                              ))}

                          </Col>

                          <Col md={12} lg={5}>

                            <Form.Group>
                              <Input name="image" placeholder="Imagem" type="file" onChange={handlePreview} />
                            </Form.Group>

                            <Form.Group>
                              <Input name="title" placeholder="Empresa" type="text" />
                            </Form.Group>

                            <Form.Group>
                              <Textarea name="description" placeholder="Descrição" />
                            </Form.Group>

                            <Form.Group className="text-end">
                              <S.Button type="submit">
                                Enviar
                              </S.Button>
                            </Form.Group>

                          </Col>

                          <Col md={12} lg={4}>

                            <h4>Ilimitado:</h4>

                            <Form.Group className="box-unlimited">
                              <Switch
                                onChange={changeUnlimited}
                                checked={unlimited == "1"}
                                className="react-switch"
                              />
                            </Form.Group>

                            <Form.Group className="d-none">
                              ATIVO<Input name="unlimited" placeholder="Sim" type="radio" value={unlimited} checked={unlimited == "1"}  onChange={e => changeUnlimited(1)}  />
                              INATIVO<Input name="unlimited" placeholder="Não" type="radio" value={unlimited} checked={unlimited == "0"}  onChange={e => changeUnlimited(0)}  />
                            </Form.Group>

                            <Form.Group className="mt-4">
                              <FormLabel><b>Peças por mês</b> <br />Somente em caso de não ilimitado</FormLabel>

                              <Input name="parts_per_month" placeholder="Peças por mês" type="text" />
                            </Form.Group>

                          </Col>


                        </Row>
                      </Container>
                    </S.CompanyForm>
                  </Col>
                </Row>
              </Container>

            </S.CompanyWrapper>
          </Col>
        </Row>
      </Container>

    </S.Container>
  );
};

export default CompanyCreate;
